/** MUI's `variant="outlined" color="error"`, which shadcn's Button has no variant for. */
export const REJECT_BUTTON =
  'border-destructive/30 text-destructive hover:bg-destructive/10 hover:text-destructive';

/** MUI's `variant="outlined" color="success"`, which shadcn's Badge has no variant for. */
export const SUCCESS_OUTLINE_BADGE = 'border-success/50 text-success';

export const CARD_INPUT = 'revy-cjk';

export const CARD_TEXTAREA = 'revy-cjk text-sm leading-[1.7]';

/** Scores are measurements, so the digits need the figure face. */
export const SCORE_INPUT = 'revy-figure';
